// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__a21c_","messages":"Chat_messages__2wQxs","dateDivider":"Chat_dateDivider__3AAr4"};